
import DatePicker from 'material-ui/DatePicker';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import MultipleSelect from '../common/multiselect.jsx';
import { Link, NavLink, withRouter } from 'react-router-dom';
import cityimg from '../../images/City.svg';
import defaultImage from '../../images/default.gif';
import postalimg from '../../images/post-office.png';
import InputMask from 'react-input-mask';
import moment from 'moment';
import s from '../../services/allservices.jsx';
import '../../stylesheet/imagehover.css';
import '../../stylesheet/personalinfo.css';
import Loader from '../loader/loader.jsx';
import FormHelperText from '@material-ui/core/FormHelperText';
import ConsumerPdfViewer from '../register/kycdocumentviewer.jsx'
import LoaderSmall from "../loader/loadersmall.jsx";
import ProfileUpdateModal from './profileupdate.jsx';
import ViewUserModal from './viewusermodal.jsx';
import Checkbox from '@material-ui/core/Checkbox'
import CardInfo from '../dashboard/cardlist'
import { getClientId, getClientSecret, buildClientHeader } from '../../utils/clientAuth';
import uuidv4 from 'uuid/v4';
import OtpPopup from '../otp/OtpPopup.js';
const styles = {
    button: {
        marginTop: 20,
        background: "#FFCE39"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    },
    underlineStyle1: {
        borderTop: "none rgb(224, 224, 224)",
        borderLeft: "none rgb(224, 224, 224)",
        borderRight: "none rgb(224, 224, 224)",
        borderBottom: "1px solid rgb(224, 224, 224)",
        bottom: "22px",
        position: "relative",
        width: "100%"
    }
};

const escapeRegexCharacters = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const getSuggestions = (value, countryState) => {
    const escapedValue = escapeRegexCharacters(value.trim());

    if (escapedValue === '') {
        return [];
    }

    const regex = new RegExp('^' + escapedValue, 'i');

    const suggestions = countryState.filter(country => regex.test(country.name));

    if (suggestions.length === 0) {
        return [
            { name: "No Country Found" }
        ];
    }

    return suggestions;
}

const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    profileState: state.getProfileReducer.profileState,
    cardState: state.getCardReducer.cardState,
})
const mapDispatchToProps = dispatch =>
({
    fetchProfileState(history) {
        dispatch(
            actions.getProfileAction(history)
        )
    },
    fetchCard(state) {
        dispatch(
            actions.getCardAction(state)
        )
    },
})
const JSEncrypt = window.JSEncrypt
class CardRequestComp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            address: localStorage.getItem('address'),
            basic: true,
            contact: true,
            disabled: true,
            disablepi: true,
            disabled1: true,
            disabledmail: true,
            disabledmailempty: true,
            disabledcontact: true,
            mailing: true,
            emailState: true,
            cityState: true,
            correcthome: true,
            correctstate: true,
            correctphone: true,
            correctEmail: true,
            correctpasscode: true,
            pincodeState: true,
            phoneState: true,
            selectedNewCard: [],
            dateofbirth: '',
            correctcountry: true,
            correctMCity: true, correctMpasscode: true, correctMadd: true, correctMstate: true, correctMcountry: true,
            coreectfirstName: true, coreectdateofbirth: true,
            firstName: '',
            lastName: '',
            gender: '',
            emailId: '',
            city: '',
            pincode: '',
            mpincode: '',
            correctCity: true,
            correctStreet: true,
            selectedCard: [],
            cardDetailsId: "",
            suggestions: [],
            value: '',
            country: '',
            countryCode: '',
            country1: '',
            countryCode1: '',
            value2: '',
            value3: '',
            value4: '',
            value5: '',
            maddress: '',
            maddress2: '',
            photoURL: '',
            mediaInfo: '',
            stateState: true,
            state1: '',
            address1: '',
            streetNumber: "",
            correctadd: true,
            addState: true,
            homeState: true,
            dateSelected: false,
            genderSelected: false,
            openModal: false,
            KycConsent: false,
            EnableCheckbox: false,
            selectedKycDetails: [],
            idType: "DRIVERS_LICENCE",
            documentFront: "",
            isvalidExpiry: true,
            carddata1: false,
            carddata2: false,
            carddata3: false,
            cardOptionSelected: 0,
            kitNumber: '',
            pin: '',
            confirmpin: '',
            PinMatchecdError: false,
            confirmPinError: false,
            address1: '',
            address2: '',
            disableActivate: false,
            otpOpen: false,
            popupLoader: false,
            otp: "",
            otpAction: null, // 'activate' | 'replacement' | 'newCard'
            countryListState: localStorage.getItem('pform') === 'AU' ? [
                {
                    "alpha3Code": "AUS",
                    "alpha2Code": "AU",
                    "name": "Australia",
                    "flag": "https://knect.oxygen-global.com/master/countries/getflag/aus.png",
                    "searchKey": "AUS-Australia",
                    "countryCallingCodes": "61"
                },
            ]
                :
                [
                    {
                        "alpha3Code": "NZL",
                        "alpha2Code": "NZ",
                        "name": "New Zealand",
                        "flag": "https://knect.oxygen-global.com/master/countries/getflag/nzl.png",
                        "searchKey": "NZL-New Zealand",
                        "countryCallingCodes": "64"
                    }
                ],
        }
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleSubmitPersonalInfo = this.handleSubmitPersonalInfo.bind(this)
        this.handleSubmitMailinginfo = this.handleSubmitMailinginfo.bind(this)

        this.handleBasic = this.handleBasic.bind(this)
        this.handleContact = this.handleContact.bind(this)
        this.handleMailing = this.handleMailing.bind(this)
        this.handleContactSubmit = this.handleContactSubmit.bind(this)
        this.handleMailingSubmit = this.handleMailingSubmit.bind(this)
        this.multipleSelect = this.multipleSelect.bind(this)
        this.handleMobile = this.handleMobile.bind(this)

    }
    componentDidMount() {

        const { publicKey } = this.props
        this.props.fetchProfileState();

        let _this = this
        setTimeout(function () {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);

                const state = {
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    accountId: encrypt.encrypt(localStorage.getItem("accountId"))
                }
                _this.props.fetchCard(state)

            }
        }, 500);

    }
    componentWillMount() {
    }

    removeemail = () => {
        this.setState({
            emailState: true
        })
    }
    removecity = () => {
        this.setState({
            cityState: true
        })
    }
    removepasscode = () => {
        this.setState({
            pincodeState: true
        })
    }

    removephone = () => {
        this.setState({
            phoneState: true
        })
    }

    removestate = () => {
        this.setState({
            stateState: true
        })
    }
    streetNumber = () => {
        this.setState({
            streetNumber: true
        })
    }
    removeadd = () => {
        this.setState({
            addState: true
        })
    }
    removehome = () => {
        this.setState({
            homeState: true
        })
    }
    multipleSelect(e) {

        e.preventDefault()
        let body = this.props.countryState

        let item = body.find(item => item.name === e.target.value)
        this.props.multiSelect({ name: [e.target.name], value: item })

    }
    handleMobile() {
        const { mobileNumber } = this.state
        let no = mobileNumber.split('')
        no.unshift('0')

        let num = no.join('')

        this.setState({
            mobileNumber: num
        })
    }

    getSuggestionValue = suggestion => {

        this.setState({
            country: suggestion.name,
            countryCode: suggestion.alpha3Code
        }, () => {

        })
        return suggestion.name;
    };

    renderSuggestion = suggestion => {
        return suggestion.name || suggestion.name;
    };

    onSuggestionsFetchRequested = ({ value }) => {

        this.setState({
            suggestions: getSuggestions(value, this.props.countryState)
        }, () => {

        });
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: this.state.country
        });
    };

    converSelectedDate = (date) => {
        var mm = date.getMonth() + 1;
        var dd = date.getDate();

        return [(dd > 9 ? '' : '0') + dd,
        (mm > 9 ? '' : '0') + mm,
        date.getFullYear(),].join('/');
    }

    converDate = (date) => {

        var mm = date.getMonth() + 1;
        var dd = date.getDate();

        return [date.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd
        ].join('-');
    }

    formatDate = (date) => {

        if (date !== undefined) {
            let day = date.getDate()
            let month = date.getMonth() + 1
            let year = date.getFullYear()

            return `${(day < 10) ? ('0' + day) : day}/${(month < 10) ? ('0' + month) : month}/${year}`
        }
    }
    handleDate = (e, date) => {

        this.setState({
            dateofbirth: this.converDate(date),
            dateSelected: true
        }, () => {

            if (this.state.firstName.length !== 0 && this.state.dateofbirth !== null) {
                this.setState({
                    disabled: false
                })
            } else {
                this.setState({
                    disabled: true
                })
            }
        })
    }

    handleLastName = (e, value) => {

        if (value.length !== 0) {
            this.setState({
                lastName: value
            }, () => {

                if (this.state.firstName.length !== 0 && this.state.dateofbirth !== null) {
                    this.setState({
                        disabled: false
                    })
                }
            })
        }
        else {
            if (this.state.firstName.length !== 0 && this.state.dateofbirth !== null) {
                this.setState({
                    lastName: "",
                    disabled: false
                })
            }

        }
    }
    handleMiddleName = (e, value) => {

        if (value.length !== 0) {
            this.setState({
                middleName: value
            }, () => {

                if (this.state.firstName.length !== 0 && this.state.dateofbirth !== null) {
                    this.setState({
                        disabled: false
                    })
                }
            })
        }
        else {
            if (this.state.firstName.length !== 0 && this.state.dateofbirth !== null) {
                this.setState({
                    lastName: "",
                    disabled: false
                })
            }

        }
    }

    handleFirstName = (e, value) => {

        let addval = value.trim()
        if (e.target.name === "firstName" && value.length !== 0) {

            this.setState({

                firstName: addval,

            }, () => {

                if (this.state.firstName.length !== 0 && this.state.dateofbirth !== null) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })

        } else {
            this.setState({
                firstName: "",
                disabled: true
            })
        }
    }
    handleMailingSubmit() {
        const { correctMCity, correctMpasscode, correctMadd, correctMstate } = this.state
        const { profileState } = this.props

        if (correctMCity === false) {
            this.setState({
                correctMCity: false,
            })
        }
        else if (correctMpasscode === false) {
            this.setState({
                correctMpasscode: false,
            })
        }
        else if (correctMadd === false) {
            this.setState({
                correctMadd: false,
            })
        }
        else if (correctMstate === false) {
            this.setState({
                correctMstate: false,
            })
        }

        else {
            this.setState({
                loader: true
            })
            let state = {
                cardDetailsId: this.state.cardDetailsId,
                address: this.state.maddress,
                address2: this.state.maddress2,
                city: this.state.mcity,
                country: this.state.country1 || profileState.body.mailingInformation.country,
                countryCode: this.state.countryCode1,
                mailingId: localStorage.getItem("mailingId"),
                memberId: localStorage.getItem("memberId"),
                pincode: this.state.mpincode,
                state: this.state.mstate1
            }
            let _this = this
            let token = "Token " + localStorage.getItem('token')
            if (state.address !== "" || state.address2 !== "" || state.city !== "" || state.country !== "" || state.pincode !== "" || state.state !== "") {
                this.setState({
                    loader: true
                })
                let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
                let traceId = getClientId();
                fetch(plink + s.update_mailing, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': token,
                        'X-Trace-Id': traceId,
                        'X-Client-APP': buildClientHeader(),
                    }),
                    body: JSON.stringify(state)
                })
                    .then(response => {
                        if (response.status === 200 || response.status === 201) {

                            toast.success(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            response.json().then(function () {
                                _this.props.fetchProfileState(this.props.history)();
                                _this.setState({
                                    mailing: !_this.state.mailing
                                })
                            })
                            this.setState({
                                loader: false
                            })
                        } else {
                            this.setState({
                                loader: false
                            })
                            toast.error(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });

                        }
                    })
            }
        }
    }

    handleContactSubmit() {
        const { correctCity, correctEmail, correctpasscode, correctadd, correctPhone, correcthome, correctstate } = this.state
        const { profileState } = this.props
        if (correctCity === false) {
            this.setState({
                correctCity: false,
            })
        }
        else if (correctEmail === false) {
            this.setState({
                correctEmail: false,
            })
        }
        else if (correctpasscode === false) {
            this.setState({
                correctpasscode: false,
            })
        } else if (correctadd === false) {
            this.setState({
                correctadd: false,
            })
        }
        else if (correctPhone === false) {
            this.setState({
                correctPhone: false,
            })
        } else if (correcthome === false) {
            this.setState({
                correcthome: false,
            })
        } else if (correctstate === false) {
            this.setState({
                correctstate: false,
            })
        }

        else {
            let state = {
                cardDetailsId: this.state.cardDetailsId,
                address: this.state.address1,
                address2: this.state.address2,
                city: this.state.city,
                country: this.state.country || profileState.body.country,
                countryCode: this.state.countryCode,
                homePhoneNumber: this.state.homePhoneNumber,
                memberId: localStorage.getItem("memberId"),
                mobileNumber: this.state.mobileNumber,
                pincode: this.state.pincode,
                state: this.state.state1,
                emailId: this.state.emailId
            }

            let _this = this
            let token = "Token " + localStorage.getItem('token')
            this.setState({
                loader: true
            })
            let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
            let traceId = getClientId();
            fetch(plink + s.update_contact, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': token,
                    'X-Trace-Id': traceId,
                    'X-Client-APP': buildClientHeader(),
                }),
                body: JSON.stringify(state)
            })
                .then(response => {
                    if (response.status === 200 || response.status === 201) {
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: true,
                            newestOnTop: true
                        });
                        response.json().then(function () {

                            _this.props.fetchProfileState(this.props.history)();
                            _this.setState({
                                contact: !_this.state.contact
                            })
                        })
                        this.setState({
                            loader: false
                        })
                    } else {
                        this.setState({
                            loader: true
                        })

                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: true,
                            newestOnTop: true
                        });

                    }
                })
        }
    }
    handleSubmitMailinginfo = () => {

        const { correctCity, correctMCity, correctMpasscode, correctMadd, correctMstate, coreectfirstName, correctEmail, correctpasscode, correctadd, correctPhone, correcthome, correctstate } = this.state
        const { profileState } = this.props

        if (correctMCity === false) {
            this.setState({
                correctMCity: false,
            })
        }
        else if (correctMpasscode === false) {
            this.setState({
                correctMpasscode: false,
            })
        }
        else if (correctMadd === false) {
            this.setState({
                correctMadd: false,
            })
        }
        else if (correctMstate === false) {
            this.setState({
                correctMstate: false,
            })
        }
        else {
            const state = {

                cardDetailsId: this.state.cardDetailsId,
                address: this.state.maddress,
                address2: this.state.maddress2,
                city: this.state.mcity,
                country: this.state.country1,
                countryCode: this.state.countryCode1,
                mailingId: localStorage.getItem("mailingId"),
                memberId: localStorage.getItem("memberId"),
                pincode: this.state.mpincode,
                state: this.state.mstate1,

            }

            let _this = this
            let token = "Token " + localStorage.getItem('token')
            this.setState({
                loader: true
            })
            let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
            let traceId = getClientId();
            fetch(plink + s.update_mailinginfo, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': token,
                    'X-Trace-Id': traceId,
                    'X-Client-APP': buildClientHeader(),
                }),
                body: JSON.stringify(state)
            })
                .then(response => {
                    if (response.status === 200 || response.status === 201) {
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: true,
                            newestOnTop: true
                        });
                        setTimeout(function () { window.location.reload(true); }, 500);
                        response.json().then(function () {

                            _this.props.fetchProfileState(this.props.history)();
                        })

                        this.setState({
                            loader: false
                        })
                    } else {
                        this.setState({
                            loader: false
                        })
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: true,
                            newestOnTop: true
                        });

                    }
                })
        }
    }

    handleSubmitPersonalInfo = () => {
        const state = {
            emailAddress: this.state.emailId,
            contactNo: this.state.mobileNumber
        }

        let _this = this
        let token = "Token " + localStorage.getItem('token')
        this.setState({
            loader: true
        })
        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let traceId = getClientId();
        fetch(plink + s.update_profile_personalInfo, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': "Token " + localStorage.getItem('token'),
                'X-Trace-Id': traceId,
                'X-Client-APP': buildClientHeader(),
            }),
            body: JSON.stringify(state)
        })
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    toast.success(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: true,
                        newestOnTop: true
                    });
                    setTimeout(function () { window.location.reload(true); }, 500);
                    response.json().then(function () {
                        _this.props.fetchProfileState(this.props.history)();
                    })

                    this.setState({
                        loader: false
                    })
                } else {
                    this.setState({
                        loader: false
                    })
                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: true,
                        newestOnTop: true
                    });

                }
            })

    }

    // ---- Request a new physical card (replacement) — now OTP-gated ----
    replacementOfCard = (onSuccess, onError) => {
        const state = {
            applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
            reasonForReplacement: this.state.reasonForReplacement,
            oldKitNo: this.state.selectedCard.kitNo,
            cardReplacementFee: this.state.selectedCard.cardReplacementFee === null ? 0 : this.state.selectedCard.cardReplacementFee,
            otp: this.state.otp,
        }
        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let traceId = getClientId();
        fetch(plink + s.replacementOfCard, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': "Token " + localStorage.getItem('token'),
                'X-Trace-Id': traceId,
                'X-Client-APP': buildClientHeader(),
            }),
            body: JSON.stringify(state)
        })
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    toast.success(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                    localStorage.setItem('newPhysicalCardRequested', true);
                    this.setState({
                        loader: false,
                        otpOpen: false,
                        popupLoader: false,
                    })
                    if (onSuccess) onSuccess();
                    this.handleClose();
                    setTimeout(function () {
                        this.props.history.push('/home')
                    }.bind(this), 500);
                }
                else if (response.status === 204) {
                    toast.success(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });

                    this.setState({
                        loader: false,
                        otpOpen: false,
                        popupLoader: false,
                    })
                    if (onSuccess) onSuccess();
                }
                else if (response.status === 422) {
                    this.setState({
                        loader: false,
                        popupLoader: false,
                    })
                    if (onError) onError(response.headers.get('message'));
                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                }
                else {
                    this.setState({
                        loader: false,
                        popupLoader: false,
                    })
                    if (onError) onError(response.headers.get('message'));
                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                }
            })

    }

    // ---- Request a physical card (from virtual) — now OTP-gated ----
    requestNewCard = (onSuccess, onError) => {
        const state = {
            addressDto: {
                address: [
                    {
                        title: "Mr",
                        address1: this.state.address1,
                        address2: this.state.address2,
                        emailId: this.state.emailId,
                        mobileNumber: this.state.mobileNumber,
                        city: this.state.city,
                        state: this.state.state1,
                        country: this.state.country,
                        pincode: this.state.pincode,
                    }
                ]
            },
            kitNo: this.state.selectedCard.kitNo,
            otp: this.state.otp,
        }

        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let traceId = getClientId();
        fetch(plink + s.requestPhysicalCard, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': "Token " + localStorage.getItem('token'),
                'X-Trace-Id': traceId,
                'X-Client-APP': buildClientHeader(),
            }),
            body: JSON.stringify(state)
        })
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    toast.success(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });

                    this.setState({
                        loader: false,
                        otpOpen: false,
                        popupLoader: false,
                    })
                    if (onSuccess) onSuccess();
                    this.handleClose1();
                    setTimeout(function () {
                        window.location.reload(true);
                    }, 500);
                }
                else if (response.status === 204) {
                    toast.success(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });

                    this.setState({
                        loader: false,
                        otpOpen: false,
                        popupLoader: false,
                    })
                    if (onSuccess) onSuccess();
                }
                else if (response.status === 422) {
                    this.setState({
                        loader: false,
                        popupLoader: false,
                    })
                    if (onError) onError(response.headers.get('message'));
                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                }
                else {
                    this.setState({
                        loader: false,
                        popupLoader: false,
                    })
                    if (onError) onError(response.headers.get('message'));
                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                }
            })

    }

    handleSubmit = () => {

        const { correctCity, correctMCity, correctMpasscode, correctMadd, correctMstate, coreectfirstName, correctEmail, correctpasscode, correctadd, correctPhone, correcthome, correctstate } = this.state
        const { profileState } = this.props
        if (correctCity === false) {
            this.setState({
                correctCity: false,
            })
        }
        else if (correctEmail === false) {
            this.setState({
                correctEmail: false,
            })
        }
        else if (correctpasscode === false) {
            this.setState({
                correctpasscode: false,
            })
        } else if (correctadd === false) {
            this.setState({
                correctadd: false,
            })
        }
        else if (correctPhone === false) {
            this.setState({
                correctPhone: false,
            })
        } else if (correcthome === false) {
            this.setState({
                correcthome: false,
            })
        } else if (correctstate === false) {
            this.setState({
                correctstate: false,
            })
        }

        else if (coreectfirstName === false) {
            this.setState({
                coreectfirstName: false,
            })
        }
        else {
            const state = {
                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                cardDetailsId: this.state.cardDetailsId,
                dateofbirth: this.state.dateSelected === true ? this.state.dateofbirth : this.state.dobDate,
                firstName: this.state.firstName,
                gender: this.state.gender,
                lastName: this.state.lastName,
                memberId: localStorage.getItem("memberId"),
                middleName: null,
                address: this.state.address1,
                address2: this.state.address2,
                city: this.state.city,
                country: this.state.country || profileState.body.country,
                countryCode: this.state.countryCode,
                homePhoneNumber: this.state.homePhoneNumber,
                mobileNumber: this.state.mobileNumber,
                pincode: this.state.pincode,
                state: this.state.state1,
                emailId: this.state.emailId,
                "mailingInformation": null,

            }

            let _this = this
            let token = "Token " + localStorage.getItem('token')
            this.setState({
                loader: true
            })
            let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
            let gid = getClientId();
            let traceId = getClientId();
            fetch(plink + s.update_profile, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': token,
                    'clientId': gid,
                    'clientSecret': getClientSecret(gid, this.state.firstName),
                    'X-Trace-Id': traceId,
                    'X-Client-APP': buildClientHeader(),

                }),
                body: JSON.stringify(state)
            })
                .then(response => {
                    if (response.status === 200 || response.status === 201) {
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: true,
                            newestOnTop: true
                        });
                        this.setState({
                            loader: false
                        })

                        this.replacementOfCard();

                    } else {
                        this.setState({
                            loader: false
                        })
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: true,
                            newestOnTop: true
                        });
                    }
                })
        }
    }

    handleBasic = () => {

        this.setState({
            basic: !this.state.basic
        })
    }
    handleContact(State) {
        if (this.state.address1 === State.address1 && this.state.city === State.city && this.state.state1 === State.state1 && this.state.mobileNumber === State.mobileNumber && this.state.address2 === State.address2 && this.state.homeState === State.homeState && this.state.country === State.country && this.state.emailId === State.emailId && this.state.pincode === State.pincode) {
            this.setState({
                disabled: false
            })
        }
        else {
            this.setState({
                disabled: true
            })
        }
        this.setState({
            contact: !this.state.contact
        })
    }
    handleMailing(State) {
        if (this.state.maddress === State.address && this.state.mcity === State.city && this.state.mstate1 === State.state && this.state.maddress2 === State.address2 && this.state.country === State.country && this.state.mpincode === State.pincode) {

            this.setState({
                disabled: false
            })
        }
        else {
            this.setState({
                disabled: true
            })
        }
        this.setState({
            mailing: !this.state.mailing
        })

    }
    toDate(date) {

        let date1 = new Date(date)
        return date1.getDate() + "/" + parseInt(date1.getMonth() + 1, 10) + "/" + date1.getFullYear()
    }
    checkObject(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                return true;
            } else {
                return false
            }

        }
    }
    componentWillReceiveProps(nextProps, date) {

        if (this.checkObject(nextProps.profileState.body)) {

            if (nextProps.profileState.body.mailingInformation === null) {

                this.setState({
                    country: nextProps.profileState.body.country,
                    address1: nextProps.profileState.body.address,
                    address2: nextProps.profileState.body.address2,
                    city: nextProps.profileState.body.city,
                    dateofbirth: nextProps.profileState.body.dateofbirth,
                    dobDate: nextProps.profileState.body.dobDate,
                    emailId: nextProps.profileState.body.emailId,
                    pincode: nextProps.profileState.body.pincode,
                    firstName: nextProps.profileState.body.firstName,
                    gender: nextProps.profileState.body.gender,
                    homePhoneNumber: nextProps.profileState.body.homePhoneNumber,
                    lastName: nextProps.profileState.body.lastName,
                    mobileNumber: nextProps.profileState.body.mobileNumber,
                    state1: nextProps.profileState.body.state,
                    countryOfIssue: nextProps.profileState.body.countryOfIssue,
                    fileType: nextProps.profileState.body.scanMIME,
                    extraData: nextProps.profileState.body.extraData,
                    idExpiry: this.converSelectedDate(new Date(nextProps.profileState.body.idExpiry)),
                    idType: nextProps.profileState.body.idType,
                    countryCode: nextProps.profileState.body.countryCode,
                    documentIssuedCountryName: nextProps.profileState.body.documentIssuedCountryName,
                    idNumber: nextProps.profileState.body.idNumber,
                    idStateOfIssue: nextProps.profileState.body.idStateOfIssue,
                    documentFront: nextProps.profileState.body.documentFront,
                    extraData: nextProps.profileState.body.extraData,
                    uploadFile: nextProps.profileState.body.documentFront === null ? true : false,
                    streetNumber: nextProps.profileState.body.streetNumber

                }, () => {

                })
            } else if (nextProps.profileState.body.mailingInformation !== null) {
                this.setState({
                    country1: nextProps.profileState.body.mailingInformation.country,
                    countryCode1: nextProps.profileState.body.mailingInformation.countryCode,
                    maddress: nextProps.profileState.body.mailingInformation.address,
                    maddress2: nextProps.profileState.body.mailingInformation.address2,
                    mcity: nextProps.profileState.body.mailingInformation.city,
                    mstate1: nextProps.profileState.body.mailingInformation.state,
                    mpincode: nextProps.profileState.body.mailingInformation.pincode,
                    country: nextProps.profileState.body.country,
                    address1: nextProps.profileState.body.address,
                    address2: nextProps.profileState.body.address2,
                    city: nextProps.profileState.body.city,
                    dateofbirth: nextProps.profileState.body.dateofbirth,
                    dobDate: nextProps.profileState.body.dobDate,
                    emailId: nextProps.profileState.body.emailId,
                    pincode: nextProps.profileState.body.pincode,
                    firstName: nextProps.profileState.body.firstName,
                    gender: nextProps.profileState.body.gender,
                    homePhoneNumber: nextProps.profileState.body.homePhoneNumber,
                    lastName: nextProps.profileState.body.lastName,
                    mobileNumber: nextProps.profileState.body.mobileNumber,
                    state1: nextProps.profileState.body.state,
                    streetNumber: nextProps.profileState.body.streetNumber,
                    countryName1: nextProps.profileState.body.countryOfIssue,

                    countryOfIssue: nextProps.profileState.body.countryOfIssue,
                    fileType: nextProps.profileState.body.scanMIME,
                    extraData: nextProps.profileState.body.extraData,
                    idExpiry: this.converSelectedDate(new Date(nextProps.profileState.body.idExpiry)),
                    idType: nextProps.profileState.body.idType,
                    countryCode: nextProps.profileState.body.countryCode,
                    documentIssuedCountryName: nextProps.profileState.body.documentIssuedCountryName,
                    idNumber: nextProps.profileState.body.idNumber,
                    idStateOfIssue: nextProps.profileState.body.idStateOfIssue,
                    documentFront: nextProps.profileState.body.documentFront,

                    uploadFile: nextProps.profileState.body.documentFront === null ? true : false,

                })
            } else if (nextProps.profileState.body.profilePicture !== null) {
                this.setState({
                    mediaInfo: nextProps.profileState.body.profilePicture.mediaInfo,
                    country: nextProps.profileState.body.country,
                    address1: nextProps.profileState.body.address,
                    address2: nextProps.profileState.body.address2,
                    city: nextProps.profileState.body.city,
                    dateofbirth: nextProps.profileState.body.dateofbirth,
                    dobDate: nextProps.profileState.body.dobDate,
                    emailId: nextProps.profileState.body.emailId,
                    pincode: nextProps.profileState.body.pincode,
                    firstName: nextProps.profileState.body.firstName,
                    gender: nextProps.profileState.body.gender,
                    homePhoneNumber: nextProps.profileState.body.homePhoneNumber,
                    lastName: nextProps.profileState.body.lastName,
                    mobileNumber: nextProps.profileState.body.mobileNumber,
                    state1: nextProps.profileState.body.state,
                    streetNumber: nextProps.profileState.body.streetNumber
                })
            }
        }

        try {
            if (nextProps.cardState && nextProps.cardState.length !== 0) {
                // var filteredG = nextProps.cardState.body.filter((val) => {
                //     return (val.cardType === "G")

                // })

                // var filteredR = nextProps.cardState.body.filter((val) => {
                //     return (val.cardType === "R")
                // })
                // var filteredCards = filteredG.concat(filteredR)
                var filteredG = nextProps.cardState.body.filter((val) => {
                    return (val.cardType === "G")
                })

                var filteredR = nextProps.cardState.body.filter((val) => {
                    return (val.cardType === "R" || val.cardType === "RD")
                })
                var filteredCards = filteredG.concat(filteredR)

                this.setState({
                    loader: false,
                    cardDetailsId: filteredCards[0].cardDetailsId,
                    selectedCard: filteredCards[0],
                    filteredCards: filteredCards,

                    selectedNewCard: [filteredCards[0]],

                })
            }
        } catch (e) {

        }

    }
    handleStreetNumber = (e, value) => {
        let addval = value.trim()
        if (value.length !== 0) {
            this.setState({
                streetNumber: e.target.value,
                correctStreet: true
            }, () => {
                if (this.state.streetNumber !== this.props.profileState.body.streetNumber) {
                    this.setState({
                        EnableCheckbox: true,
                    }, () => {
                        if (this.state.streetNumber !== null && this.state.streetNumber.length !== 0 && this.state.address1 !== null && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.city !== null && this.state.pincode.length !== 0 && this.state.pincode !== null && this.state.mobileNumber.length !== 0 && this.state.mobileNumber !== null && this.state.emailId.length !== 0 && this.state.emailId !== null && this.state.state1.length !== 0 && this.state.state1 !== null && this.state.country.length !== 0 && this.state.country !== null
                            && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                            this.setState({
                                disabled: false,

                            })
                        } else {
                            this.setState({
                                disabled: true,

                            })
                        }
                    })
                }
                else {
                    this.setState({
                        EnableCheckbox: false,

                    })
                }

            })
        }
        else {
            this.setState({
                streetNumber: "",
                correctStreet: false,
                disabled: true
            })
        }
    }

    handleaddress1 = (e, value) => {

        let addval = value.trim()

        if (value.length !== 0) {
            this.setState({
                address1: addval
            }, () => {
                if (this.state.address1 !== this.props.profileState.body.address1) {
                    this.setState({
                        EnableCheckbox: true

                    }, () => {
                        if (this.state.address1 !== null && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.city !== null && this.state.pincode.length !== 0 && this.state.pincode !== null && this.state.mobileNumber.length !== 0 && this.state.mobileNumber !== null && this.state.emailId.length !== 0 && this.state.emailId !== null && this.state.state1.length !== 0 && this.state.state1 !== null && this.state.country.length !== 0 && this.state.country !== null
                            && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                            this.setState({
                                disabled: false,

                            })
                        } else {
                            this.setState({
                                disabled: true,

                            })
                        }
                    })
                }

                else {
                    this.setState({
                        EnableCheckbox: false
                    })

                }

            })
        }
        else {
            this.setState({
                address1: "",
                disabled: true
            })
        }
    }

    handleaddress2 = (e, value) => {
        let addval = value.trim()
        this.setState({
            address2: addval,
        }, () => {
            if (this.state.address2 !== this.props.profileState.body.address2) {
                this.setState({
                    EnableCheckbox: true
                }, () => {
                    if (this.state.streetNumber !== "" && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0 && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                        this.setState({
                            disabled: false
                        })
                    } else {
                        this.setState({
                            disabled: true
                        })
                    }
                })
            }
            else {
                this.setState({
                    EnableCheckbox: false
                })

            }

        })
    }

    handleStatedropdown = (event, index, value) => {

        this.setState({
            state1: value
        }, () => {
            if (this.state.state1 !== this.props.profileState.body.state) {
                this.setState({
                    EnableCheckbox: true
                }, () => {
                    if (this.state.streetNumber !== "" && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0 && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                        this.setState({
                            disabled: false
                        })
                    } else {
                        this.setState({
                            disabled: true
                        })
                    }
                })
            }
            else {
                this.setState({
                    EnableCheckbox: false
                })

            }

        })
    }

    handleMailingStatedropdown = (event, index, value) => {

        this.setState({
            mstate1: value
        }, () => {

            if (this.state.maddress !== null && this.state.maddress !== "" && this.state.mcity !== null && this.state.mcity !== "" && this.state.maddress !== null && this.state.mpincode !== "" && this.state.mstate1 !== "" && this.state.country1 !== "") {

                this.setState({
                    disabled1: false
                })
            } else {

                this.setState({
                    disabled1: true
                })
            }
        })

    }
    handleIDStatedropdown = (event, index, value) => {

        this.setState({
            idStateOfIssue: value
        }, () => {
            if (this.state.idStateOfIssue !== this.props.profileState.body.idStateOfIssue) {
                this.setState({
                    EnableCheckbox: true
                }, () => {
                    if (this.state.streetNumber !== "" && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0
                        && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                        this.setState({
                            disabled: false
                        })
                    } else {
                        this.setState({
                            disabled: true
                        })
                    }
                })
            }
            else {
                this.setState({
                    EnableCheckbox: false
                })

            }
        })
    }
    handlestate1 = (e, value) => {
        let addval = value.trim()
        if (value.length !== 0) {
            this.setState({
                state1: addval
            }, () => {
                if (this.state.state1 !== this.props.profileState.body.state) {
                    this.setState({
                        EnableCheckbox: true

                    }, () => {
                        if (this.state.streetNumber !== "" && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0 && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                            this.setState({
                                disabled: false
                            })
                        } else {
                            this.setState({
                                disabled: true
                            })
                        }
                    })
                }
                else {
                    this.setState({
                        EnableCheckbox: false
                    })

                }
            })
        }
        else {
            this.setState({
                state1: "",
                disabled: true
            })
        }
    }

    handelemail = (e, value) => {
        let addval = value.trim()
        if (e.target.name === "emailId" && value.length !== 0) {
            // eslint-disable-next-line
            if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,40}))$/.test(addval)) {
                this.setState({
                    correctEmail: true,
                    emailId: addval,

                }, () => {
                    if (this.state.emailId !== this.props.profileState.body.emailId) {
                        this.setState({
                        }, () => {
                            if (this.state.emailId.length !== 0 && this.state.mobileNumber.length !== 0) {
                                this.setState({
                                    disablepi: false
                                })
                            } else {
                                this.setState({
                                    disablepi: true
                                })
                            }
                        })
                    }
                    else {
                        this.setState({
                            EnableCheckbox: false
                        })

                    }
                })

            }
        }
        else {
            this.setState({
                emailId: "",
                disabled: true,
            })
        }
    }
    onFieldChange = (e, value) => {

        const { name } = e.target
        this.setState({
            [name]: e.target.value,
            disabled: false
        })
        if ((this.state.idStateOfIssue !== this.props.profileState.body.idStateOfIssue) || (this.state.idNumber !== this.props.profileState.body.idNumber) || (this.state.extraData !== this.props.profileState.body.extraData)) {
            this.setState({
                EnableCheckbox: true
            }, () => {
                if (this.state.streetNumber !== "" && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0 && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
        }
        else {
            this.setState({
                EnableCheckbox: false
            })
        }
    }

    handelmobileNumber = (e, value) => {
        let addval = value.trim()
        var regx = /^\d{3,20}$/
        if (e.target.name === 'mobileNumber' && value.length >= 3) {
            if (regx.test(addval)) {
                this.setState({
                    correctphone: true,
                    mobileNumber: addval,
                }, () => {
                    if (this.state.mobileNumber !== this.props.profileState.body.mobileNumber) {
                        this.setState({
                        }, () => {
                            if (this.state.mobileNumber !== "" && this.state.emailId.length !== 0) {
                                this.setState({
                                    disablepi: false
                                })
                            } else {
                                this.setState({
                                    disablepi: true
                                })
                            }
                        })
                    }
                })
            } else {
                this.setState({
                    correctphone: false,
                    mobileNumber: "",
                })
            }
        }
        else {
            this.setState({
                mobileNumber: "",
                correctphone: false,
                disabled: true
            })
        }
    }
    handelhomePhoneNumber = (e, value) => {
        var regx = /^\d{3,20}$/
        if (e.target.name === 'homePhoneNumber' && value.length !== 0) {
            if (regx.test(e.target.value)) {
                this.setState({
                    correcthome: true,
                    homePhoneNumber: e.target.value,

                }, () => {
                    if (this.state.streetNumber !== "" && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0) {
                        this.setState({
                            disabled: false
                        })
                    } else {
                        this.setState({
                            disabled: true
                        })
                    }
                })
            } else {
                this.setState({
                    correcthome: false,

                })
            }
        }
        else {
            this.setState({
                disabled: true
            })
        }
    }

    handlecity = (e, value) => {
        if (e.target.value.length !== 0) {
            this.setState({
                city: e.target.value
            }, () => {
                if (this.state.city !== this.props.profileState.body.city) {
                    this.setState({
                        EnableCheckbox: true
                    }, () => {
                        if (this.state.streetNumber !== "" && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0 && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                            this.setState({
                                disabled: false
                            })
                        } else {
                            this.setState({
                                disabled: true
                            })
                        }
                    })
                } else {
                    this.setState({
                        correcthome: false,
                    })
                }
            })
        }
        else {
            this.setState({
                city: "",
                disabled: true
            })
        }
    }

    handlepincode = (e, value) => {
        var regx = /^\d{4,4}$/
        if (e.target.name === "pincode" && value.length !== 0) {

            if (regx.test(e.target.value)) {
                this.setState({
                    correctpasscode: true,
                    pincode: e.target.value,
                }, () => {
                    if (this.state.pincode !== this.props.profileState.body.pincode) {
                        this.setState({
                            EnableCheckbox: true
                        }, () => {
                            if (this.state.streetNumber !== "" && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0 && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                                this.setState({
                                    disabled: false
                                })
                            } else {
                                this.setState({
                                    disabled: true
                                })
                            }
                        })
                    }
                })
            } else {
                this.setState({
                    correctpasscode: false,
                })
            }
        }
        else {
            this.setState({
                pincode: "",
                disabled: true
            })
        }
    }

    handlemaddress1 = (e, value) => {

        this.setState({
            maddress: e.target.value
        }, () => {
            if (this.state.maddress !== null && this.state.maddress !== "" && this.state.mcity !== null && this.state.mcity !== "" && this.state.mpincode !== null && this.state.mpincode !== "" && this.state.mstate1 !== "" && this.state.country1 !== "") {

                this.setState({
                    disabled1: false
                })
            } else {
                this.setState({
                    disabled1: true
                })
            }
        })

    }

    handlemaddress2 = (e, value) => {

        this.setState({
            maddress2: e.target.value,

        }, () => {
            if (this.state.maddress !== null && this.state.maddress !== "" && this.state.mcity !== null && this.state.mcity !== "" && this.state.mpincode !== null && this.state.mpincode !== "" && this.state.mstate1 !== "" && this.state.country1 !== "") {

                this.setState({
                    disabled1: false
                })
            } else {
                this.setState({
                    disabled1: true
                })
            }
        })

    }

    handlemstate1 = (e, value) => {

        this.setState({
            mstate1: e.target.value
        }, () => {
            if (this.state.maddress !== null && this.state.maddress !== "" && this.state.mcity !== null && this.state.mcity !== "" && this.state.mpincode !== null && this.state.mpincode !== "" && this.state.mstate1 !== "" && this.state.country1 !== "") {

                this.setState({
                    disabled1: false
                })
            } else {
                this.setState({
                    disabled1: true
                })
            }
        })

    }
    handleSpace = () => {
    }

    handlemcity = (e, value) => {

        this.setState({
            mcity: e.target.value
        }, () => {
            if (this.state.maddress !== null && this.state.maddress !== "" && this.state.mcity !== null && this.state.mcity !== "" && this.state.mpincode !== null && this.state.mpincode !== "" && this.state.mstate1 !== "" && this.state.country1 !== "") {
                this.setState({
                    disabled1: false
                })
            } else {
                this.setState({
                    disabled1: true
                })
            }
        })

    }

    handlemcountry = (e) => {
        const { name, term } = e.target

        this.setState({
            country1: term,
            countryCode1: e.target.value

        }, () => {

            if (this.state.maddress !== null && this.state.maddress !== "" && this.state.mcity !== null && this.state.mcity !== "" && this.state.mpincode !== null && this.state.mpincode !== "" && this.state.mstate1 !== "" && this.state.country1 !== "") {
                this.setState({
                    disabled1: false
                })
            } else {
                this.setState({
                    disabled1: true
                })
            }
        })

    }
    handlempincode = (e, value) => {

        if (e.target.name === "mpincode") {
            let regx1 = /^\d{4,4}$/

            if (regx1.test(e.target.value)) {

                this.setState({
                    correctMpasscode: true,
                    mpincode: e.target.value,

                }, () => {

                    if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0 && this.state.country1.length !== 0) {
                        this.setState({
                            disabled1: false
                        })
                    } else {
                        this.setState({
                            disabled1: true
                        })
                    }
                })
            }
            else {
                this.setState({
                    correctMpasscode: false,
                    mpincode: e.target.value,
                    disabled: true

                })
            }

        }
    }

    handlemaddress1empty = (e, value) => {

        if (e.target.value.length !== 0) {
            this.setState({
                maddress: e.target.value,
                disabledmailempty: false
            }, () => {
                if (this.state.streetNumber !== "" && this.state.address1 !== null && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.city !== null && this.state.pincode.length !== 0 && this.state.pincode !== null && this.state.mobileNumber.length !== 0 && this.state.mobileNumber !== null && this.state.emailId.length !== 0 && this.state.emailId !== null && this.state.state1.length !== 0 && this.state.state1 !== null && this.state.country.length !== 0 && this.state.country !== null) {
                    this.setState({
                        disabled: false
                    }, () => {

                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
        }

    }
    handlemcountryIdDocument = (e) => {

        const { name, term } = e.target

        if (e.target.value.length !== 0) {
            this.setState({
                countryOfIssue: e.target.value,
                disabled: false,

            }, () => {
                if (this.state.countryOfIssue !== this.props.profileState.body.countryOfIssue) {
                    this.setState({
                        EnableCheckbox: true
                    }, () => {
                        if (this.state.streetNumber !== "" && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0 && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                            this.setState({
                                disabled: false
                            })
                        } else {
                            this.setState({
                                disabled: true
                            })
                        }
                    })
                }
            })
        }
    }

    handlemaddress2empty = (e, value) => {

        if (value.length !== 0) {

            this.setState({
                maddress2: value
            })
        }
    }

    handlemstate1empty = (e, value) => {

        if (value.length !== 0) {
            this.setState({
                mstate1: value,
                disabledmailempty: false
            }, () => {
                if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0) {
                    this.setState({
                        disabledmailempty: false
                    })
                } else {
                    this.setState({
                        disabledmailempty: true
                    })
                }
            })
        } else {
            this.setState({
                disabledmailempty: true
            })
        }
    }

    handlemcityempty = (e, value) => {

        if (value.length !== 0) {
            this.setState({
                mcity: value,
                disabledmailempty: false
            }, () => {
                if (this.state.maddress.length !== 0 && this.state.mcity.length !== 0 && this.state.mpincode.length !== 0 && this.state.mstate1.length !== 0) {
                    this.setState({
                        disabledmailempty: false
                    })
                } else {
                    this.setState({
                        disabledmailempty: true
                    })
                }
            })
        } else {
            this.setState({
                disabledmailempty: true
            })
        }
    }

    handlemcountryempty = (e) => {
        const { name, term } = e.target
        this.setState({ [name]: e.target.value })

        if (e.target.value.length !== 0) {
            this.setState({
                country: term,
                countryCode: e.target.value,
            }, () => {
                if (this.state.countryCode !== this.props.profileState.body.countryCode) {
                    this.setState({
                        EnableCheckbox: true
                    }, () => {
                        if (this.state.streetNumber !== "" && this.state.address1.length !== 0 && this.state.city.length !== 0 && this.state.pincode.length !== 0 && this.state.mobileNumber.length !== 0 && this.state.emailId.length !== 0 && this.state.state1.length !== 0 && this.state.country.length !== 0 && this.state.KycConsent === true && this.state.isvalidExpiry === true) {
                            this.setState({
                                disabled: false
                            })
                        } else {
                            this.setState({
                                disabled: true
                            })
                        }
                    })
                }

            });
        }
    }

    handlempincodeempty = (e, value) => {

        var regx = /^[0-9]{4,4}$/;
        if (e.target.name === "mpincode" && value.length !== 0) {
            if (regx.test(value)) {
                this.setState({
                    correctpasscode: true,
                    mpincode: value,
                    disabledmailempty: false

                })
            } else {
                this.setState({
                    correctpasscode: false,
                    disabledmailempty: true

                })
            }
        }
    }

    handleSelect1 = (event, index, value) => {
        const { filteredCards } = this.state
        this.setState({ cardDetailsId: value }, () => {
            for (let i = 0; i < filteredCards.length; i++) {
                if (this.state.cardDetailsId === filteredCards[i].cardDetailsId) {

                    this.setState({

                        selectedCard: filteredCards[i],
                        selectedNewCard: [filteredCards[i]],

                    })
                }
            }
        });

    }
    handleClick = event => {
        const { target = {} } = event || {};
        target.value = "";
    };
    onFileChange = async (e) => {

        let _this = this
        const file1 = e.target.files[0]

        let filetype = file1.type

        var reader = new FileReader();
        reader.onloadend = function () {
            let result1 = reader.result

            let res = result1.slice(result1.indexOf(",") + 1)

            _this.setState({
                documentFront: res,
                fileType: filetype,
                fileName: file1.name,
                fileSize: file1.size,

                EnableCheckbox: true

            }, () => {
                this.state.KycConsent === true ?
                    this.setState({
                        disabled: false
                    })
                    :
                    this.setState({
                        disabled: true
                    })

                if (file1.size > 1000000) {
                    toast.error('Uploaded File Size Should be Less Than 1 MB', {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                }
            })
        }
        reader.readAsDataURL(file1);

    }

    kycResponse = (memberId) => {
        this.getFrankiebyRequestId(memberId)
        this.setState({
            openModal: true
        })
    }
    getFrankiebyRequestId(requestId) {
        let _this = this
        let path = `${s.getFrankieData}${requestId}`
        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let gfid = getClientId();
        let traceId = getClientId();
        fetch(plink + path, {
            headers: new Headers({
                'Authorization': `Token ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json',
                'clientId': gfid,
                'clientSecret': getClientSecret(gfid, this.state.memberId),
                'X-Trace-Id': traceId,
                'X-Client-APP': buildClientHeader(),
            })
        }).then(response => {
            if (response.status === 200) {
                response.json().then(json => {

                    _this.setState({
                        openModal: true,
                        selectedKycDetails: json,
                    })
                    toast.success(response.headers.get('message'), {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        draggablePercent: 60
                    })
                })
            }
            if (response.status === 401) {
                if (this.props.history !== undefined) {
                    this.props.history.push('/sessionOut')
                }
            }
        })
    }
    closeModal = () => {
        this.setState({
            openModal: false
        })
    }
    handleCheckbox = () => {
        this.setState({
            KycConsent: !this.state.KycConsent,
        })
    }
    handleReasonForReplacement = (event, index, value) => {
        this.setState({
            reasonForReplacement: value,
            cardReplacementFee: this.state.selectedCard.cardReplacementFee
        }, () => {
        })
    }
    insertDecimal = (num) => {
        return ((num * 100) / 100).toFixed(2);
    }
    handleConfirmReplaceModal = () => {
        document.getElementById('replacementOfCardModal').style.display = 'block'
    }
    handleClose = () => {
        document.getElementById("replacementOfCardModal").style.display = "none"
    }
    handleRequestModal = () => {
        document.getElementById('requestModal').style.display = 'block'
    }
    handleClose1 = () => {
        document.getElementById("requestModal").style.display = "none"
    }
    showCardOption = (val) => {
        this.setState({
            cardOptionSelected: val,
        }, () => {
        })

    }

    validateActivateCard = () => {
        if (this.state.kitNumber === "" || this.state.expiry === "" || this.state.pin === "" || this.state.confirmpin === "" || this.state.confirmPinError === true) {
            this.setState({
                disableActivate: false,
                actualExpiryNumber: '',
            })
        } else {
            this.setState({
                disableActivate: true
            })
        }

    }

    handleValue(val) {
        if (this.state.pin.includes('_')) {
            this.setState({
                pinError: true,
                toggleType1: "text"
            }, () => {
                this.validateActivateCard()
            })
        } else {
            this.setState({
                pinError: false,
                toggleType1: "password"
            }, () => {
                this.validateActivateCard()
            })
        }

    }

    handleValueChange(event, val) {
        let _this = this

        _this.setState({
            [event.target.name]: event.target.value,
        }, () => {

            if (_this.state.pin.length <= 4) {
                this.setState({
                    toggleType1: "text"
                })

                if (_this.state.pin.length === 4) {
                    if (_this.state.confirmpin.length === 4) {

                        if (_this.state.pin === _this.state.confirmpin) {
                            _this.setState({
                                PinMatchecdError: false,
                            })
                        } else {
                            _this.setState({
                                PinMatchecdError: true,
                            })
                        }
                    }
                }

            }
        })

        if (_this.state.pin.length === 4 || _this.state.pin.length >= 0) {
            _this.setState({
                pinError: false,
            })
        } else {
            _this.setState({
                pinError: true,
            })
        }

    }

    handleValueConfirm(val) {

        if (this.state.confirmpin.includes("_")) {
            this.setState({
                toggleText: "text",
                confirmPinError: true,
                disableActivate: true,
            }, () => {
                this.validateActivateCard()
            })
        } else {
            this.setState({

                toggleText: "password",
                confirmPinError: false,
            }, () => {
                this.validateActivateCard()
            })
        }

    }

    handleValueChangeconfirm(e, val) {
        let _this = this
        _this.setState({
            confirmpin: e.target.value,
        }, () => {

            if (_this.state.confirmpin.length <= 4) {
                this.setState({
                    toggleText: "text",
                })

                if (_this.state.confirmpin.length <= 4) {
                    if (_this.state.pin.length === 4) {
                        if (_this.state.confirmpin.length === 4) {
                            if (_this.state.pin === _this.state.confirmpin) {
                                _this.setState({
                                    PinMatchecdError: false,
                                    disableActivate: true,
                                })
                            } else {
                                _this.setState({
                                    PinMatchecdError: true,
                                    disableActivate: false,
                                })
                            }
                        }
                    }
                }
            }
        })

    }

    onChange = (e, value) => {
        this.setState({
            [e.target.name]: value
        })
    }

    // ---- Shared OTP gate for Activate Card / Replacement / New Physical Card ----
    callFinalOtpAction = (actionType, onSuccess, onError) => {
        if (actionType === 'activate') {
            this.handleActivateCard(onSuccess, onError);
        } else if (actionType === 'replacement') {
            this.replacementOfCard(onSuccess, onError);
        } else if (actionType === 'newCard') {
            this.requestNewCard(onSuccess, onError);
        }
    };

    runOtpGate = (actionType) => {
        const otpValidation = localStorage.getItem("otpValidation");

        if (otpValidation !== "true") {
            // Skip OTP modal — call final API directly
            this.setState({
                otp: "",
                popupLoader: true,
                otpAction: actionType,
            }, () => {
                this.callFinalOtpAction(actionType, null, null);
            });
            return;
        }

        // otpValidation === "true" — show OTP modal and send OTP to email
        this.setState({
            otpOpen: true,
            popupLoader: false,
            otpAction: actionType,
        }, () => {
            this.handleRequestOtp(false);
        });
    };

    // for otp open — Activate Card
    otpPopupOpenModal = () => {
        if (this.state.pin !== this.state.confirmpin) {
            this.setState({
                kitNumber: "",
                expiry: "",
                actualExpiryNumber: "",
                pin: "",
                confirmpin: "",
                loader: false,
            });
            toast.error("PIN And Confirm PIN do not match !", {
                position: "top-right",
                autoClose: true,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            return;
        }

        this.runOtpGate('activate');
    };

    // for otp open — Request a New Physical Card (Lost/Stolen replacement)
    replacementConfirmYes = () => {
        this.runOtpGate('replacement');
    };

    // for otp open — Request a Physical Card (from virtual card)
    requestNewCardConfirmYes = () => {
        this.runOtpGate('newCard');
    };

    // for otp close
    otpPopupCloseModal = () => {
        this.setState({
            otpOpen: false,
        });
    };

    handleOtpSubmit = (otp, onSuccess, onError) => {
        this.setState({
            otp: otp,
            popupLoader: true,
        }, () => {
            this.callFinalOtpAction(this.state.otpAction, onSuccess, onError);
        });
    };

    handleRequestOtp = () => {
        const { publicKey } = this.props;
        let _this = this;

        _this.setState({
            loader: true,
        });

        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let traceId = getClientId();
        console.log("Plink of Card request api", plink)
        if (publicKey.status === 200) {
            const public_Key = publicKey.body.publickey;
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(public_Key);

            const payload = {
                cardDetailsId: encrypt.encrypt(this.state.cardDetailsId),
                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',

            };

            let token = "Token " + localStorage.getItem('token');
            let gid = getClientId();

            return fetch(plink + s.OtpToReissueCard, {
                method: "POST",
                headers: new Headers({
                    "Content-Type": 'application/json',
                    'Authorization': token,
                    // 'clientId': gid,
                    // 'clientSecret': getClientSecret(gid, this.state.cardDetailsId),
                    'X-Trace-Id': traceId,
                    'X-Client-APP': buildClientHeader(),
                }),
                body: JSON.stringify(payload)
            }).then((response) => {
                if (
                    response.status === 200 ||
                    response.status === 201 ||
                    response.status === 204
                ) {
                    _this.setState({
                        loader: false
                    });
                    toast.success(response.headers.get("message"), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                    });
                } else if (response.status === 400) {
                    _this.setState({
                        loader: false,
                    });
                } else if (response.status === 422) {
                    _this.setState({
                        loader: false,
                    });
                    let message = response.headers.get("message");

                    response.json()
                        .then((json) => {
                            if (json && json.message) {
                                message = json.message;
                            }
                            toast.error(message, {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                draggablePercent: 60,
                            });
                        })
                        .catch(() => {
                            toast.error(message, {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                draggablePercent: 60,
                            });
                        });
                } else if (response.status === 401) {
                    _this.setState({
                        loader: false,
                    });
                    if (this.props.history !== undefined) {
                        this.props.history.push('/sessionOut');
                    }
                } else {
                    toast.error(response.headers.get("message"), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                    });
                    _this.setState({
                        loader: false,
                    });
                }
                return response;
            });
        } else {
            // publicKey wasn't ready — don't leave the UI stuck in a loading state
            _this.setState({
                loader: false,
            });
        }
    };

    handleActivateCard = (onSuccess, onError) => {
        const { publicKey } = this.props;
        const { pin, confirmpin } = this.state;

        let _this = this;
        if (pin === confirmpin) {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);

                let newPinstate = {
                    cardPin: encrypt.encrypt(this.state.pin),
                    expiryDate: encrypt.encrypt(this.state.actualExpiryNumber),
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    accountId: localStorage.getItem('accountId'),
                    kitNo: this.state.kitNumber,
                    otp: this.state.otp,
                };
                this.setState({
                    loader: true,
                });

                let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
                let gactivateid = getClientId();
                let traceId = getClientId();
                fetch(plink + s.activateReIssueCard, {
                    method: "POST",
                    headers: new Headers({
                        "Content-Type": "application/json",
                        'clientId': gactivateid,
                        'clientSecret': getClientSecret(gactivateid, newPinstate.kitNo),
                        'X-Trace-Id': traceId,
                        'X-Client-APP': buildClientHeader(),

                    }),
                    body: JSON.stringify(newPinstate),
                }).then((response) => {
                    if (response.status === 200 || response.status === 201 || response.status === 204) {

                        toast.success(response.headers.get("message"), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false,
                        });
                        this.setState({
                            kitNumber: "",
                            expiry: "",
                            actualExpiryNumber: "",
                            pin: "",
                            confirmpin: "",
                            loader: false,
                            otpOpen: false,
                            popupLoader: false,
                        });
                        if (onSuccess) onSuccess();
                        setTimeout(function () {
                            _this.props.history.push("/home");
                        }.bind(_this), 800);

                    } else if (response.status === 422) {
                        this.setState({
                            loader: false,
                            popupLoader: false,
                        });
                        if (onError) onError(response.headers.get('message'));
                        toast.error(response.headers.get("message"), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false,
                        });
                    } else if (response.status === 400) {
                        toast.success(response.headers.get("message"), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false,
                        });
                        this.setState({
                            loader: false,
                            popupLoader: false,
                        });
                        if (onError) onError(response.headers.get('message'));
                    }
                    else {
                        this.setState({
                            loader: false,
                            popupLoader: false,
                        });
                        if (onError) onError(response.headers.get('message'));
                        toast.error(response.headers.get("message"), {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                    }
                });
            }
        } else {
            this.setState({
                kitNumber: "",
                expiry: "",
                actualExpiryNumber: "",
                pin: "",
                confirmpin: "",
                loader: false,
            });
            toast.error("PIN And Confirm PIN do not match !", {
                position: "top-right",
                autoClose: true,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }

    };
    onChangeExpiry = (e) => {
        const { name } = e.target
        let string = e.target.value;
        this.setState({ [name]: e.target.value }
            , () => {
                const expiryNumber = string.replace(/\//g, "");
                const actualExpiryNumber = expiryNumber.replace(/_/g, "");

            });

    }

    handleExpiry = (e) => {

        const { name } = e.target
        this.setState({ [name]: e.target.value }
            , () => {

            });

        let string = e.target.value;
        const expiryNumber = string.replace(/\//g, "");
        const actualExpiryNumber = expiryNumber.replace(/_/g, "");

        if (actualExpiryNumber.length >= 4) {
            this.setState({
                expiryVerified: true,
                rederFeedback1: false,
                actualExpiryNumber: actualExpiryNumber,
                title: "Please enter valid expiry number",
                disabled: false
            }, () => {
                this.validateActivateCard()
            })
        }

    }

    render() {
        const { reasonForReplacement, basic, homeState, correcthome, correctstate, correctcountry, correctphone, emailState, cityState, correctpasscode, pincodeState, correctEmail, addState, correctCity, stateState, correctadd, selectedCard, cardDetailsId, coreectfirstName, correctMadd, correctMCity, correctMpasscode, correctMstate, } = this.state
        const { profileState, cardState } = this.props
        const { filteredCards, carddata1, carddata2, carddata3, cardOptionSelected, confirmPinError, PinMatchecdError } = this.state

        const { pinError, expiryError } = this.state;
        const msg = "PIN must be of 4 digits"
        const msg1 = "Invalid Expiry Date"
        const msg2 = "PIN and Confirm PIN do not match !"
        const errorDiv = <div className=" simsfont offset-md-2 col-sm-12 " style={{ marginTop: 10, color: "#d64a4a", fontSize: "13px" }}>
            {msg}
        </div>
        const errorDiv1 = <div className="simsfont offset-md-2 col-sm-12 " style={{ marginTop: -15, color: "#d64a4a", fontSize: "13px" }}>
            {msg1}
        </div>
        const errorDiv2 = <div className=" simsfont offset-md-2 col-sm-12 " style={{ marginTop: 10, color: "#d64a4a", fontSize: "13px" }}>
            {msg2}
        </div>

        return (
            <div className="col-sm-12" >

                {this.state.otpOpen && (
                    <OtpPopup
                        open={this.state.otpOpen}
                        onClose={this.otpPopupCloseModal}
                        handleRequestOtp={this.handleRequestOtp}
                        onSubmit={this.handleOtpSubmit}
                        loading={this.state.popupLoader}
                    />
                )}

                {this.state.selectedKycDetails && <ViewUserModal
                    open={this.state.openModal}
                    onClose={this.closeModal}
                    details={this.state.selectedKycDetails}
                />}

                <div className="modal" id="replacementOfCardModal" style={{ display: "none" }} role="dialog">
                    <div className="modal-dialog ">
                        <div className="modal-content " style={{ marginTop: "150px", background: "#333" }}>
                            <div className="modal-header" style={{ padding: "3px", borderBottom: "none", height: "45px" }}>
                                <div className="col-sm-12" style={{ marginTop: "7px" }}>
                                    <div className="row">
                                        <div className="col-sm-6" style={{ fontSize: "19px", fontWeight: "600", color: "rgb(255, 255, 255)" }}>
                                            <span>Request a Card</span>
                                        </div>
                                        <div className="offset-4 col-sm-2" style={{ float: "right", color: "rgb(255, 255, 255)" }}>
                                            <button type="button" style={{ color: "#fff" }} onClick={this.handleClose} className="close" data-dismiss="modal">&times;</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-body text-center" style={{ backgroundColor: "#fff" }}>
                                <div className="col-sm-12" >
                                    <i className="fa fa-question fa-4x mb-3 animated rotateIn" style={{ color: "#333" }}></i>
                                </div>
                                <div className="col-sm-12" style={{ fontSize: "20px" }}>
                                    <span>Are you sure you want to request a new Physical Card? </span>
                                </div>
                                <div className="col-sm-12" >
                                    <button type="button" className="btn " onClick={this.handleClose} style={{ backgroundColor: "#333", color: "#fff", marginRight: "10px", fontSize: "14px", fontWeight: "bold", marginTop: "8px" }} data-dismiss="modal"> No </button>
                                    <button type="button" className="btn " style={{ backgroundColor: "#333", color: "#fff", fontSize: "14px", fontWeight: "bold", marginTop: "8px", minWidth: "60px" }} onClick={this.replacementConfirmYes} data-dismiss="modal"> Yes </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="modal" id="requestModal" style={{ display: "none" }} role="dialog">
                    <div className="modal-dialog ">
                        <div className="modal-content " style={{ marginTop: "150px", background: "#333" }}>
                            <div className="modal-header" style={{ padding: "3px", borderBottom: "none", height: "45px" }}>
                                <div className="col-sm-12" style={{ marginTop: "7px" }}>
                                    <div className="row">
                                        <div className="col-sm-6" style={{ fontSize: "19px", fontWeight: "600", color: "rgb(255, 255, 255)" }}>
                                            <span>Request a Card</span>
                                        </div>
                                        <div className="offset-4 col-sm-2" style={{ float: "right", color: "rgb(255, 255, 255)" }}>
                                            <button type="button" style={{ color: "#fff" }} onClick={this.handleClose1} className="close" data-dismiss="modal">&times;</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-body text-center" style={{ backgroundColor: "#fff" }}>
                                <div className="col-sm-12" >
                                    <i className="fa fa-question fa-4x mb-3 animated rotateIn" style={{ color: "#333" }}></i>
                                </div>
                                <div className="col-sm-12" style={{ fontSize: "20px" }}>
                                    <span>Are you sure you want to request a  Physical Card? </span>
                                </div>
                                <div className="col-sm-12" >
                                    <button type="button" className="btn " onClick={this.handleClose1} style={{ backgroundColor: "#333", color: "#fff", marginRight: "10px", fontSize: "14px", fontWeight: "bold", marginTop: "8px" }} data-dismiss="modal"> No </button>
                                    <button type="button" className="btn " style={{ backgroundColor: "#333", color: "#fff", fontSize: "14px", fontWeight: "bold", marginTop: "8px", minWidth: "60px" }} onClick={this.requestNewCardConfirmYes} data-dismiss="modal"> Yes </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {this.props.profileState && this.props.profileState.body && this.state.loader ? <div style={{ marginTop: "200px" }}><Loader /></div> :
                    <div className="row">
                        <div className="col-sm-12 mt-3" style={{ padding: "0px 15px" }}>
                            <div className="row">

                                <div className="header-style" style={{ padding: "5px 20px 0px 15px" }}>
                                    <h4 className='logmainheading mainheading ml-2'>Request Card</h4>
                                </div>
                            </div>
                        </div>

                        {(profileState.status === 200 && (selectedCard.cardStatus === "Locked" || selectedCard.cardStatus === "Unlocked" || selectedCard.cardStatus === "Replaced")) ?
                            <div className="col-md-12 mb-3" style={{ padding: "0px 8px" }}>
                                <div className=" col-sm-12">
                                    {(selectedCard.typeOfCard === 'PHYSICAL' && localStorage.getItem('newPhysicalCardRequested') === 'false') &&
                                        <div className="col-sm-12">

                                            <div className="row cardOptions" onClick={() => this.showCardOption(1)}>
                                                <h4>Request a New Physical Card</h4>
                                                <p>My physical card is Lost / Stolen</p>
                                                <p>A new card will be shipped to you within 10 business days. Please enter your postal address below</p>
                                            </div>
                                            {cardOptionSelected === 1 &&

                                                <div className="row mb-3 ">
                                                    <div className="col-md-12 col-sm-12 ">
                                                        <div className="row">
                                                            <div className="col-md-4 col-sm-4 ">
                                                                <div className="row input-group" >
                                                                    <SelectField
                                                                        floatingLabelText="Reason For Replacement"
                                                                        onChange={this.handleReasonForReplacement}
                                                                        className="input-width required simsfont"
                                                                        name="reasonForReplacement"
                                                                        value={this.state.reasonForReplacement}
                                                                    >
                                                                        <MenuItem className="menuitem" value="Lost Card" primaryText="Lost Card" />
                                                                        <MenuItem className="menuitem" value="Stolen Card" primaryText="Stolen Card" />
                                                                    </SelectField>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 col-sm-12 nopadding">
                                                        <div className="row input-group" >
                                                            <div className="col-sm-4" >
                                                                <TextField
                                                                    hintText="Start Typing"
                                                                    floatingLabelText="Address Line 1"
                                                                    type="text"
                                                                    name="address1"
                                                                    autoComplete='off'
                                                                    maxLength="60"
                                                                    defaultValue={profileState.body.address || null}
                                                                    className="input-width required"
                                                                    onChange={this.handleaddress1}
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    onFocus={this.removeadd}
                                                                    errorText={addState ? correctadd ? null : "Not a valid address" : "This field is required"}
                                                                />
                                                            </div>
                                                            <div className="col-sm-4" >
                                                                <TextField
                                                                    hintText="Start Typing"
                                                                    floatingLabelText="Address Line 2"
                                                                    type="text"
                                                                    defaultValue={profileState.body.address2 || null}
                                                                    name="address2"
                                                                    maxLength="60"
                                                                    className="input-width"
                                                                    onChange={this.handleaddress2}
                                                                    autoComplete='off'
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                />
                                                            </div>
                                                            <div className="col-sm-4 " style={{ cursor: "pointer" }}>
                                                                <label className="form-control-placeholder mb-2"
                                                                    onChange={this.handlemcountryempty} name="country" id="required" style={{ fontSize: "12px", color: "grey", position: "relative", top: "0px", cursor: "pointer" }}>Country</label>

                                                                <MultipleSelect
                                                                    className="items-container1"
                                                                    image
                                                                    name="country"
                                                                    items={this.state.countryListState}
                                                                    kiey="alpha3Code"
                                                                    value="alpha3Code"
                                                                    default={profileState.body.country}
                                                                    description="name"
                                                                    flag="flag"
                                                                    term="name"
                                                                    searchKey="name"
                                                                    selectValue={this.handlemcountryempty.bind(this)}
                                                                    disabled={true}
                                                                    errorText={correctcountry ? null : "Not a valid name"}
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="col-md-12 col-sm-12 nopadding">
                                                        <div className="row input-group" >
                                                            <div className="col-sm-4" >
                                                                <TextField
                                                                    hintText="Start Typing"
                                                                    floatingLabelText="City"
                                                                    defaultValue={profileState.body.city || null}
                                                                    type="text"
                                                                    name="city"
                                                                    maxLength="30"
                                                                    className="input-width required"
                                                                    onChange={this.handlecity}
                                                                    autoComplete='off'
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    onFocus={this.removecity}
                                                                    underlineStyle={styles.underlineStyle1}
                                                                    errorText={cityState ? correctCity ? null : "Not a valid city" : "This field is required"}
                                                                />
                                                            </div>
                                                            <div className="col-sm-4" >
                                                                {(this.state.countryCode !== "AUS") ?
                                                                    <TextField
                                                                        hintText="Start Typing"
                                                                        floatingLabelText="State"
                                                                        type="text"
                                                                        defaultValue={profileState.body.state || null}
                                                                        name="state1"
                                                                        maxLength="50"
                                                                        autoComplete='nope'
                                                                        className="input-width required"
                                                                        onChange={this.handlestate1}
                                                                        onFocus={this.removestate}
                                                                        underlineFocusStyle={styles.focusStyle}
                                                                        underlineStyle={styles.underlineStyle1}
                                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                                        errorText={stateState ? correctstate ? null : "Not a valid state" : "This field is required"}
                                                                    />
                                                                    :

                                                                    <SelectField
                                                                        floatingLabelText="State"
                                                                        onChange={this.handleStatedropdown}
                                                                        className="input-width required simsfont"
                                                                        name="state1"
                                                                        value={this.state.state1}
                                                                    >
                                                                        <MenuItem className="menuitem" value="ACT" primaryText="ACT" />
                                                                        <MenuItem className="menuitem" value="NSW" primaryText="NSW" />
                                                                        <MenuItem className="menuitem" value="NT" primaryText="NT" />
                                                                        <MenuItem className="menuitem" value="QLD" primaryText="QLD" />
                                                                        <MenuItem className="menuitem" value="SA" primaryText="SA" />
                                                                        <MenuItem className="menuitem" value="TAS" primaryText="TAS" />
                                                                        <MenuItem className="menuitem" value="VIC" primaryText="VIC" />
                                                                    </SelectField>

                                                                }
                                                            </div>
                                                            <div className="col-sm-4" >
                                                                <TextField
                                                                    hintText="Start Typing"
                                                                    floatingLabelText="Post Code"
                                                                    type="text"
                                                                    name="pincode"
                                                                    maxLength="4"
                                                                    onChange={this.handlepincode.bind(this)}
                                                                    autoComplete='off'
                                                                    className="input-width required"
                                                                    defaultValue={profileState.body.pincode || null}
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    onFocus={this.removepasscode}
                                                                    errorText={pincodeState ? correctpasscode ? null : "Not a valid Postcode" : "This field is required"}
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="col-md-12 col-sm-12 ">
                                                        <div className="row input-group" >
                                                            <div className="col-sm-4 nopadding " >
                                                                <TextField
                                                                    hintText="Start Typing"
                                                                    floatingLabelText="Email"
                                                                    type="text"
                                                                    defaultValue={profileState.body.emailId || null}
                                                                    name="emailId"
                                                                    maxLength="50"
                                                                    className="input-width required"
                                                                    onChange={this.handelemail}
                                                                    autoComplete='none'
                                                                    onFocus={this.removeemail}
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    errorText={emailState ? correctEmail ? null : "Not a valid email" : "This field is required"}
                                                                />
                                                            </div>
                                                            <div className="col-sm-4" >
                                                                <TextField
                                                                    hintText="Start Typing"
                                                                    floatingLabelText="Mobile Number"
                                                                    type="text"
                                                                    defaultValue={profileState.body.mobileNumber || null}
                                                                    name="mobileNumber"
                                                                    maxLength="20"
                                                                    autoComplete='off'
                                                                    className="input-width required"
                                                                    onChange={this.handelmobileNumber.bind(this)}
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    errorText={correctphone ? null : "Not a valid phone number"}
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="col-md-12 col-sm-12">
                                                        <div className="row" >
                                                            <div className="col-md-5 col-sm-5">
                                                                <div className="row input-group float-left" >
                                                                    <RaisedButton
                                                                        label="Request a New Physical Card"
                                                                        onClick={this.handleConfirmReplaceModal}
                                                                        disabled={!this.state.reasonForReplacement}
                                                                        style={styles.button}
                                                                        backgroundColor="#333"
                                                                        labelColor="#fff"
                                                                    />
                                                                </div>
                                                            </div>
                                                            {this.state.loader === true &&
                                                                <div className="col-sm-1" style={{ marginTop: "-6px", marginLeft: "-26px", width: "30% !mportant" }} >
                                                                    <LoaderSmall />
                                                                </div>}
                                                        </div>
                                                    </div>
                                                    <hr />
                                                </div>
                                            }
                                        </div>
                                    }

                                    {(selectedCard.typeOfCard === 'PHYSICAL' && localStorage.getItem('newPhysicalCardRequested') === 'true') &&
                                        <div className="col-sm-12">

                                            <div className="row cardPlaced">
                                                <h4>Physical Card Requested</h4> <br />
                                                <p>Your physical card request has been received. </p>
                                                <p>It will be sent to your postal address within 14 days. If it does not arrive, please contact us.</p>
                                            </div>
                                        </div>
                                    }

                                    {selectedCard.typeOfCard === 'VIRTUAL' &&
                                        <div className="col-sm-12">

                                            <div className="row cardOptions" onClick={() => this.showCardOption(2)}>
                                                <h4>Request a Physical Card</h4>
                                                <p>I have a digital card, I want a physical card </p>
                                                <p>A new card will be shipped to you within 10 business days. Please enter your postal address below</p>
                                            </div>
                                            {cardOptionSelected === 2 &&
                                                <div className="row mb-3">
                                                    <div className="col-md-12 col-sm-12 nopadding">
                                                        <div className="row input-group" >
                                                            <div className="col-sm-4" >
                                                                <TextField
                                                                    hintText="Start Typing"
                                                                    floatingLabelText="Address Line 1"
                                                                    type="text"
                                                                    name="address1"
                                                                    autoComplete='off'
                                                                    maxLength="60"
                                                                    defaultValue={profileState.body.address || null}
                                                                    className="input-width required"
                                                                    onChange={this.handleaddress1}
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    onFocus={this.removeadd}
                                                                    errorText={addState ? correctadd ? null : "Not a valid address" : "This field is required"}
                                                                />
                                                            </div>
                                                            <div className="col-sm-4" >
                                                                <TextField
                                                                    hintText="Start Typing"
                                                                    floatingLabelText="Address Line 2"
                                                                    type="text"
                                                                    defaultValue={profileState.body.address2 || null}
                                                                    name="address2"
                                                                    maxLength="60"
                                                                    className="input-width"
                                                                    onChange={this.handleaddress2}
                                                                    autoComplete='off'
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                />
                                                            </div>
                                                            <div className="col-sm-4 " style={{ cursor: "pointer" }}>
                                                                <label className="form-control-placeholder mb-2"
                                                                    onChange={this.handlemcountryempty} name="country" id="required" style={{ fontSize: "12px", color: "grey", position: "relative", top: "0px", cursor: "pointer" }}>Country</label>

                                                                <MultipleSelect
                                                                    className="items-container1"
                                                                    image
                                                                    name="country"
                                                                    items={this.state.countryListState}
                                                                    kiey="alpha3Code"
                                                                    value="alpha3Code"
                                                                    default={profileState.body.country}
                                                                    description="name"
                                                                    flag="flag"
                                                                    term="name"
                                                                    searchKey="name"
                                                                    selectValue={this.handlemcountryempty.bind(this)}
                                                                    errorText={correctcountry ? null : "Not a valid name"}
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="col-md-12 col-sm-12 nopadding">
                                                        <div className="row input-group" >
                                                            <div className="col-sm-4" >
                                                                <TextField
                                                                    hintText="Start Typing"
                                                                    floatingLabelText="City"
                                                                    defaultValue={profileState.body.city || null}
                                                                    type="text"
                                                                    name="city"
                                                                    maxLength="30"
                                                                    className="input-width required"
                                                                    onChange={this.handlecity}
                                                                    autoComplete='off'
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    onFocus={this.removecity}
                                                                    underlineStyle={styles.underlineStyle1}
                                                                    errorText={cityState ? correctCity ? null : "Not a valid city" : "This field is required"}
                                                                />
                                                            </div>
                                                            <div className="col-sm-4" >
                                                                {(this.state.countryCode !== "AUS") ?
                                                                    <TextField
                                                                        hintText="Start Typing"
                                                                        floatingLabelText="State"
                                                                        type="text"
                                                                        defaultValue={profileState.body.state || null}
                                                                        name="state1"
                                                                        maxLength="50"
                                                                        autoComplete='nope'
                                                                        className="input-width required"
                                                                        onChange={this.handlestate1}
                                                                        onFocus={this.removestate}
                                                                        underlineFocusStyle={styles.focusStyle}
                                                                        underlineStyle={styles.underlineStyle1}
                                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                                        errorText={stateState ? correctstate ? null : "Not a valid state" : "This field is required"}
                                                                    />
                                                                    :

                                                                    <SelectField
                                                                        floatingLabelText="State"
                                                                        onChange={this.handleStatedropdown}
                                                                        className="input-width required simsfont"
                                                                        name="state1"
                                                                        value={this.state.state1}
                                                                    >
                                                                        <MenuItem className="menuitem" value="ACT" primaryText="ACT" />
                                                                        <MenuItem className="menuitem" value="NSW" primaryText="NSW" />
                                                                        <MenuItem className="menuitem" value="NT" primaryText="NT" />
                                                                        <MenuItem className="menuitem" value="QLD" primaryText="QLD" />
                                                                        <MenuItem className="menuitem" value="SA" primaryText="SA" />
                                                                        <MenuItem className="menuitem" value="TAS" primaryText="TAS" />
                                                                        <MenuItem className="menuitem" value="VIC" primaryText="VIC" />
                                                                    </SelectField>

                                                                }
                                                            </div>
                                                            <div className="col-sm-4" >
                                                                <TextField
                                                                    hintText="Start Typing"
                                                                    floatingLabelText="Post Code"
                                                                    type="text"
                                                                    name="pincode"
                                                                    maxLength="4"
                                                                    onChange={this.handlepincode.bind(this)}
                                                                    autoComplete='off'
                                                                    className="input-width required"
                                                                    defaultValue={profileState.body.pincode || null}
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    onFocus={this.removepasscode}
                                                                    errorText={pincodeState ? correctpasscode ? null : "Not a valid Postcode" : "This field is required"}
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="col-md-12 col-sm-12 ">
                                                        <div className="row input-group" >

                                                            <div className="col-sm-4 nopadding " >
                                                                <TextField
                                                                    hintText="Start Typing"
                                                                    floatingLabelText="Email"
                                                                    type="text"
                                                                    defaultValue={profileState.body.emailId || null}
                                                                    name="emailId"
                                                                    maxLength="50"
                                                                    className="input-width required"
                                                                    onChange={this.handelemail}
                                                                    autoComplete='none'
                                                                    onFocus={this.removeemail}
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    errorText={emailState ? correctEmail ? null : "Not a valid email" : "This field is required"}
                                                                />
                                                            </div>
                                                            <div className="col-sm-4" >
                                                                <TextField
                                                                    hintText="Start Typing"
                                                                    floatingLabelText="Mobile Number"
                                                                    type="text"
                                                                    defaultValue={profileState.body.mobileNumber || null}
                                                                    name="mobileNumber"
                                                                    maxLength="20"
                                                                    autoComplete='off'
                                                                    className="input-width required"
                                                                    onChange={this.handelmobileNumber.bind(this)}
                                                                    underlineFocusStyle={styles.focusStyle}
                                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                                    errorText={correctphone ? null : "Not a valid phone number"}
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="col-md-12 col-sm-12">
                                                        <div className="row" >
                                                            <div className="col-md-5 col-sm-5">
                                                                <div className="row input-group float-left" >
                                                                    <RaisedButton
                                                                        label="Request a Physical Card"
                                                                        onClick={this.handleRequestModal}
                                                                        style={styles.button}
                                                                        backgroundColor="#333"
                                                                        labelColor="#fff"
                                                                    />
                                                                </div>
                                                            </div>
                                                            {this.state.loader === true &&
                                                                <div className="col-sm-1" style={{ marginTop: "-6px", marginLeft: "-26px", width: "30% !mportant" }} >
                                                                    <LoaderSmall />
                                                                </div>}
                                                        </div>
                                                    </div>
                                                    <hr />

                                                </div>
                                            }
                                        </div>
                                    }

                                    <div className="col-sm-12">
                                        <div className="row cardOptions" onClick={() => this.showCardOption(3)}>
                                            <h4>Activate New Physical Card</h4>
                                            <p>I have received my physical card and would like to activate it.</p>
                                        </div>
                                        {cardOptionSelected === 3 &&
                                            <div className="row mb-3">
                                                <div className="col-md-12 col-sm-12 nopadding">
                                                    <div className="row input-group">
                                                        <div className="col-sm-4" >
                                                            <TextField
                                                                hintText="Card Reference"
                                                                floatingLabelText="Card Reference"
                                                                type="text"
                                                                name="kitNumber"
                                                                autoComplete='off'
                                                                maxLength="60"
                                                                value={this.state.kitNumber}
                                                                className="input-width required"
                                                                onChange={this.onChange}
                                                                underlineFocusStyle={styles.focusStyle}
                                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                                                onFocus={this.removeadd}
                                                                onBlur={this.validateActivateCard}
                                                            />
                                                        </div>
                                                        <div className="col-sm-4" >
                                                            <div className="group">
                                                                <InputMask mask="99/99"
                                                                    name="expiry"
                                                                    id="expiry"
                                                                    ref="item"
                                                                    onChange={this.onChangeExpiry}
                                                                    placeholder="MM/YY"
                                                                    onBlur={this.handleExpiry}

                                                                    defaultValue={this.state.actualExpiryNumber}

                                                                />
                                                                <span className="highlight"></span>
                                                                <span className="bar"></span>
                                                                <label className='simsfont '>Card Expiry Date<span style={{ color: "#e32", fontSize: "18px" }}> *</span></label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 col-sm-12 nopadding">
                                                    <div className="row input-group" >

                                                        <div className="col-md-4 ">
                                                            <div className="row input-group" >
                                                                <div className="col-sm-10">
                                                                    <div className="group">
                                                                        <InputMask mask="9999" maskchar="*" type={this.state.toggleType1} value={this.state.pin} name="pin" onChange={(event, value) => { this.handleValueChange(event, value) }}
                                                                            onBlur={(value) => { this.handleValue(value); }} />
                                                                        <span className="highlight"></span>
                                                                        <span className="bar"></span>
                                                                        <label className='simsfont'>Set PIN</label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>

                                                        <div className="col-md-4">
                                                            <div className="row input-group" >
                                                                <div className="col-sm-10">
                                                                    <div className="group" >
                                                                        <InputMask mask="9999" maskchar="*" type={this.state.toggleText} value={this.state.confirmpin} name="confirmpin" onChange={(e, value) => { this.handleValueChangeconfirm(e, value); }}
                                                                            onBlur={(e, value) => { this.handleValueConfirm(e, value); }} />
                                                                        <span className="highlight"></span>
                                                                        <span className="bar"></span>
                                                                        <label className='simsfont'>Confirm PIN</label>
                                                                    </div>
                                                                    <span toggle="#cofirmpin" className={`${this.state.toggleConfirmPINIcon} field-icon toggle-password`} style={{ float: "right", right: "10px", position: "absolute", top: "40px", cursor: "pointer" }} onClick={this.toggleConfirmPIN} ></span>
                                                                    {confirmPinError && errorDiv}
                                                                    {PinMatchecdError && errorDiv2}
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                                <div className="col-md-12 col-sm-12">
                                                    <div className="row" >
                                                        <div className="col-md-5 col-sm-5">
                                                            <div className="row input-group float-left" >
                                                                <RaisedButton
                                                                    label="Activate Card"
                                                                    onClick={this.otpPopupOpenModal}
                                                                    style={styles.button}
                                                                    disabled={!this.state.disableActivate}
                                                                    backgroundColor="#333"
                                                                    labelColor="#fff"
                                                                />
                                                            </div>
                                                        </div>
                                                        {this.state.loader === true &&
                                                            <div className="col-sm-1" style={{ marginTop: "-6px", marginLeft: "-26px", width: "30% !mportant" }} >
                                                                <LoaderSmall />
                                                            </div>}
                                                    </div>
                                                </div>
                                                <hr />

                                            </div>
                                        }
                                    </div>
                                </div>

                            </div>
                            : <div> </div>}
                    </div>}
            </div>
        );
    }
}
CardRequestComp.defaultProps = {
    profileState: {
        status: 600
    },
    cardState: {
        status: 600
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CardRequestComp));



// WEBPACK FOOTER //
// ./src/components/myprofile/requestcardcomp.jsx